import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone, MapPin, Heart } from "lucide-react";
import { SITE, NAV_LINKS } from "../../data/site";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-brand-navy-dark text-white/90 mt-32 relative overflow-hidden"
        >
            <div className="absolute inset-0 grain-bg opacity-30 pointer-events-none" />
            <div className="container-fe py-20 relative">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    <div className="lg:col-span-1">
                        <div className="flex items-center gap-2.5 mb-5">
                            <div className="h-11 w-11 rounded-xl bg-brand-green flex items-center justify-center text-white font-display font-extrabold text-xl">
                                F
                            </div>
                            <div>
                                <div className="font-display font-bold text-white text-base">
                                    Formar Estructura
                                </div>
                                <div className="text-[10px] uppercase tracking-[0.22em] text-brand-green font-bold">
                                    Fundación · Ibagué
                                </div>
                            </div>
                        </div>
                        <p className="text-sm text-white/70 leading-relaxed">
                            {SITE.description} Trabajamos con dignidad, esperanza y transparencia.
                        </p>
                        <div className="mt-6 flex gap-2">
                            <a
                                href={SITE.facebook}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-facebook"
                                aria-label="Facebook"
                                className="h-10 w-10 rounded-full bg-white/10 hover:bg-brand-green flex items-center justify-center transition-colors"
                            >
                                <Facebook size={18} />
                            </a>
                            <a
                                href={SITE.instagram}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-instagram"
                                aria-label="Instagram"
                                className="h-10 w-10 rounded-full bg-white/10 hover:bg-brand-green flex items-center justify-center transition-colors"
                            >
                                <Instagram size={18} />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-5">
                            Navegación
                        </h4>
                        <ul className="space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-link-${l.to.replace("/", "") || "home"}`}
                                        className="text-sm text-white/70 hover:text-brand-green transition-colors"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-5">
                            Únete
                        </h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/donar" className="text-sm text-white/70 hover:text-brand-green transition-colors">
                                    Hacer una donación
                                </Link>
                            </li>
                            <li>
                                <Link to="/voluntariado" className="text-sm text-white/70 hover:text-brand-green transition-colors">
                                    Ser voluntario
                                </Link>
                            </li>
                            <li>
                                <Link to="/transparencia" className="text-sm text-white/70 hover:text-brand-green transition-colors">
                                    Aliados estratégicos
                                </Link>
                            </li>
                            <li>
                                <Link to="/admin" className="text-sm text-white/40 hover:text-brand-green transition-colors">
                                    Acceso administrativo
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-5">
                            Contacto
                        </h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3 text-sm text-white/70">
                                <MapPin size={16} className="mt-0.5 text-brand-green shrink-0" />
                                <span>{SITE.address}</span>
                            </li>
                            <li className="flex items-center gap-3 text-sm text-white/70">
                                <Phone size={16} className="text-brand-green shrink-0" />
                                <a href={`tel:${SITE.phoneRaw}`} className="hover:text-white">{SITE.phone}</a>
                            </li>
                            <li className="flex items-center gap-3 text-sm text-white/70 break-all">
                                <Mail size={16} className="text-brand-green shrink-0" />
                                <a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 items-center justify-between">
                    <p className="text-xs text-white/50">
                        © {new Date().getFullYear()} {SITE.name}. Todos los derechos reservados. NIT registrado en Cámara de Comercio de Ibagué.
                    </p>
                    <p className="text-xs text-white/50 flex items-center gap-1.5">
                        Hecho con <Heart size={12} className="fill-brand-green text-brand-green" /> en Ibagué, Tolima
                    </p>
                </div>
            </div>
        </footer>
    );
};
